<template>
  <ToggleHeader
    title="Keeper information"
    text-colour="has-text-dark"
    :visible="visible"
    @toggle="toggle"
  >
    <transition
      enter-active-class="animated faster fadeIn"
      leave-active-class="animated faster fadeOut"
      mode="out-in"
    >
      <div v-if="visible">
        <hr class="mt-0 has-background-dark" />
        <div class="columns mb-6">
          <div class="column is-12">
            <div class="columns is-vcentered is-mobile">
              <div class="column is-5 has-text-weight-light">
                <p>Number of former keepers</p>
              </div>
              <div class="column has-text-weight-semibold">
                <span>{{ formerKeepersCount }}</span>
              </div>
            </div>
            <div class="columns is-vcentered is-mobile">
              <div class="column is-5 has-text-weight-light">
                <p>Date of last keeper change</p>
              </div>
              <div class="column has-text-weight-semibold">
                <span>{{ lastKeeperChangeDate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </ToggleHeader>
</template>

<script>
import { formatDate } from '@/utils/date.utils.ts'

export default {
  name: 'KeeperInformation',
  components: {
    ToggleHeader: () => import('core/components/ToggleHeader')
  },
  props: {
    timeline: {
      type: [Object, Boolean],
      required: false,
      default: () => null
    }
  },
  data: () => ({
    visible: true,
    notAvailable: 'Not available'
  }),
  computed: {
    keeperChanges() {
      if (!this.timeline || !this.timeline.events) return []
      return this.timeline.events.filter(e => e.type === 'KeeperChange')
    },
    formerKeepersCount() {
      if (!this.timeline || !this.timeline.events) return this.notAvailable
      return this.keeperChanges.length
    },
    lastKeeperChangeDate() {
      if (!this.keeperChanges.length) return this.notAvailable
      const mostRecent = [...this.keeperChanges].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      )[0]
      return formatDate(mostRecent.date)
    }
  },
  methods: {
    toggle() {
      const action = this.visible ? 'close' : 'open'
      this.$mxp.track(`${action}_keeper_information_collapsible`)
      this.visible = !this.visible
    }
  }
}
</script>
